<div *ngIf="isPageReady" id="printable-invoice" class="h-full">
    <div uni-flex-row class="h1 mt-1">
      <span style="flex: auto">Unitec Distribution Systems</span>
      <span>Invoice</span>
    </div>
    <div uni-flex-row class="mt-1">
      <span style="flex: auto; font-style: italic">Innovative Apparel Distribution Systems<br />Tax Id: 52-0551098</span>
      <span style="font-size: 1.25rem; font-style: italic;">{{account.accountName}}</span>
    </div>

    <div uni-flex-row class="mt-3 align-items-start">
      <uni-field uni-flex-item label="Bill">
        <textarea pInputText rows="5" [ngModel]="billingAddress" readonly="readonly"></textarea>
      </uni-field>
      <uni-field uni-flex-item label="Ship">
        <textarea pInputText rows="5" [ngModel]="shippingAddress" readonly="readonly"></textarea>
      </uni-field>

    </div>

    <div uni-flex-row class="mt-3 mb-3 justify-between">
      <uni-field style="width: 20%" label="Invoice #">
        <input pInputText [ngModel]="invoiceNumber" readonly="readonly" />
      </uni-field>
      <uni-field style="width: 15%" label="Invoice Date">
        <input pInputText [ngModel]="invoiceDate | date : 'MM/dd/yyyy'" readonly="readonly" />
      </uni-field>
      <uni-field style="width: 15%" label="Due Date">
        <input pInputText [ngModel]="dueDate | date : 'MM/dd/yyyy'" readonly="readonly" />
      </uni-field>
      <uni-field style="width: 28%" label="Your PO Number">
        <input pInputText [ngModel]="poNumber" readonly="readonly" />
      </uni-field>
      <uni-field style="width: 15%" label="Amount Due">
        <input pInputText [ngModel]="totalAmt | currency" readonly="readonly" style="text-align: right" />
      </uni-field>
    </div>

    <table class="grid-print">
      <thead>
        <tr>
          <th>Employee</th>
          <th>Returned Item</th>
          <th>Config Name</th>
          <th>Features</th>
          <th class="col-right">Qty</th>
          <th class="col-right">Restock Fee</th>
          <th class="col-right">Total</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let d of flatDetails">
          <tr>
            <td>{{ d.employee }}</td>
            <td>{{ d.desc }}</td>
            <td>{{ d.ptConfigName }}</td>
            <td>{{ d.featureChoicesExtract }}</td>
            <td class="col-right">{{ d.qty }}</td>
            <td class="col-right">{{ d.unitPrice }}</td>
            <td class="col-right">{{ d.total }}</td>
          </tr>
        </ng-container>
      </tbody>
    </table>

</div>
